/*
 * bt-edition-cart.js — self-contained AJAX add-to-cart + branded toast for the
 * linked-edition pages. Plain <form data-bt-cart-add> elements (no Dawn
 * <product-form>); one delegated document-level submit handler covers every
 * add-to-cart form on the page. Shows an "Added to cart" toast instead of
 * redirecting to /cart, and refreshes the header cart bubble via the Sections
 * API. The Buy Now <a> inside the same form never submits (its onclick returns
 * false to open Fastrr), so only Add to Cart reaches this handler.
 */
(function () {
  if (window.__btEditionCartInit) return;
  window.__btEditionCartInit = true;

  var TOAST_MS = 3200;
  var hideTimer;

  function buildToast() {
    var t = document.createElement('div');
    t.id = 'bt-toast';
    t.className = 'bt-toast';
    t.setAttribute('role', 'status');
    t.setAttribute('aria-live', 'polite');
    t.innerHTML =
      '<span class="bt-toast__check" aria-hidden="true">' +
        '<svg viewBox="0 0 24 24" width="15" height="15"><polyline points="20 6 9 17 4 12"></polyline></svg>' +
      '</span>' +
      '<span class="bt-toast__msg">Added to cart</span>' +
      '<a class="bt-toast__link" href="/cart">View cart</a>';
    document.body.appendChild(t);
    return t;
  }

  function toast(msg, isError) {
    var t = document.getElementById('bt-toast') || buildToast();
    t.querySelector('.bt-toast__msg').textContent = msg || 'Added to cart';
    t.classList.toggle('bt-toast--error', !!isError);
    // force reflow so the transition replays if shown back-to-back
    void t.offsetWidth;
    t.classList.add('bt-toast--show');
    clearTimeout(hideTimer);
    hideTimer = setTimeout(function () { t.classList.remove('bt-toast--show'); }, TOAST_MS);
  }

  function refreshCartBubble(sections) {
    var html = sections && sections['cart-icon-bubble'];
    if (!html) return;
    var current = document.getElementById('cart-icon-bubble');
    if (current) current.innerHTML = html;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('form[data-bt-cart-add]') : null;
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('button[type="submit"], [name="add"]');
    if (btn) {
      if (btn.getAttribute('aria-disabled') === 'true') return;
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('bt-loading');
    }

    var data = new FormData(form);
    data.append('sections', 'cart-icon-bubble');
    data.append('sections_url', window.location.pathname);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          toast((res.body && (res.body.description || res.body.message)) || 'Could not add to cart', true);
          return;
        }
        toast('Added to cart');
        refreshCartBubble(res.body.sections);
        // keep any other cart UI (drawer/header) in sync if the theme listens
        try {
          if (window.PUB_SUB_EVENTS && typeof publish === 'function') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bt-edition-cart', productVariantId: data.get('id') });
          }
        } catch (err) {}
        document.dispatchEvent(new CustomEvent('bt-edition:cart-added'));
      })
      .catch(function () { toast('Could not add to cart — please try again', true); })
      .finally(function () {
        if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('bt-loading'); }
      });
  }, false);
})();
